/**
 * Shared client-side validators. The backend re-validates everything; these
 * exist only to give quick inline feedback.
 */

/**
 * True when `value` is empty (optional field left blank) or a valid http(s) URL.
 * Mirrors `isOptionalHttpUrl` in backend/src/routes/testexecution.js.
 */
export function isOptionalHttpUrl(value) {
  if (value === undefined || value === null || String(value).trim() === '') return true;
  try {
    const { protocol } = new URL(String(value).trim());
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}
